export default __webpack_public_path__ + "static/media/landing.2f0b7caa.png";